import { documentService } from "./documentService";

/**
 * Extracts deduplicated, valid (non-placeholder) chunk IDs from step data.
 *
 * Priority:
 *  1. chunk_ids / chunkIds  (if non-empty after filtering placeholders)
 *  2. chunk_sources[].chunk_id  (fallback when chunk_ids is absent or empty)
 *
 * @param {object} stepData - An Action node from the behavior tree.
 * @returns {string[]} Unique, valid chunk IDs.
 */
export function getValidChunkIds(stepData) {
  if (!stepData) return [];

  const directIds = stepData.chunk_ids ?? stepData.chunkIds;

  // Filter directIds first so fabricated IDs (e.g. "safety_002") don't
  // block the fallback to chunk_sources.
  const validDirect = Array.isArray(directIds)
    ? directIds.filter(id => id && !documentService.isPlaceholderChunkId(id))
    : [];

  const fromSources = Array.isArray(stepData.chunk_sources)
    ? stepData.chunk_sources.map(c => c.chunk_id).filter(Boolean)
    : [];

  const candidates = validDirect.length > 0 ? validDirect : fromSources;

  return [...new Set(candidates)].filter(
    id => id && !documentService.isPlaceholderChunkId(id),
  );
}
